import { Component, ViewChild } from '@angular/core';
import { UserModel, RoleModel } from 'src/app/models';
import { UsersService } from 'src/app/services/firestore';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ActionProgressComponent } from 'src/app/modules/shared/action-progress/action-progress.component';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  styleUrls: ['./edit-user-modal.component.scss'],
})
export class EditUserModalComponent {
  user: UserModel;
  loading: boolean;
  canWriteUsers: boolean;
  roles: RoleModel[];

  @ViewChild(ActionProgressComponent) actionProgress: ActionProgressComponent;
  constructor(
    private usersService: UsersService,
    public modal: BsModalRef,
    private toaster: ToastrService,
    private fns: AngularFireFunctions,
    private authService: AuthService,
  ) {
    this.user = new UserModel();
    this.loading = false;
  }

  async save() {
    this.actionProgress.start();
    this.loading = true;

    try {
      const user = await this.authService.currentUser;
      await firstValueFrom(this.usersService.updateUser(this.user, user!.uid));
      this.modal.hide();
      this.toaster.success('User updated');
    } catch (error) {
      this.toaster.error(error);
    }
    this.actionProgress.complete();
    this.loading = false;
  }
}
